import React from "react";
import FormTextField from "../../fields/basic/TextField";
import { useFormHandlerContext } from "../../../../controllers/formController";
import { useFormContext } from "react-hook-form";

export const FormHeader: React.FC = () => {
  const { isCreateMode, isProcessing } = useFormHandlerContext();
  const { getValues } = useFormContext();

  const fieldExists = (fieldName: string): boolean =>
    getValues().hasOwnProperty(fieldName) && getValues()[fieldName];

  const showPublishedId = !isCreateMode && fieldExists("published_id");

  return (
    <>
      {showPublishedId && (
        <FormTextField
          name="published_id"
          label="Intellexus ID"
          static
          disabled={isProcessing}
        />
      )}
    </>
  );
};

export default FormHeader;
